import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pl-4 pt-2" }
const _hoisted_2 = { class: "pl-4" }
const _hoisted_3 = { class: "pl-4" }

import { computed } from "vue";
import { tenkoTypes } from "@/services/consts";
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'IttenkoForm',
  props: {
    modelValue: {},
    errors: {},
    isEditableUser: { type: Boolean },
    windowInnerWidth: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit;

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { class: "text-form pl-4 pr-3 mb-3 align-center" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: __props.windowInnerWidth > 800 ? 2 : 3
        }, {
          default: _withCtx(() => [
            _createElementVNode("h6", _hoisted_1, _toDisplayString(_unref(i18n).global.t('pages.operationOffices.form.ittenko.setting')), 1)
          ]),
          _: 1
        }, 8, ["cols"]),
        _createVNode(_component_v_col, {
          cols: __props.windowInnerWidth > 800 ? 10 : 9
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { class: "align-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_switch, {
                      "hide-details": "auto",
                      modelValue: modelValue.value.is_active_ittenko,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue.value.is_active_ittenko) = $event)),
                      disabled: !props.isEditableUser,
                      color: "blue"
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "8" }, {
                  default: _withCtx(() => [
                    (modelValue.value.is_active_ittenko)
                      ? (_openBlock(), _createBlock(_component_v_select, {
                          key: 0,
                          "hide-details": "auto",
                          class: "small",
                          modelValue: modelValue.value.tenko_type,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue.value.tenko_type) = $event)),
                          disabled: !props.isEditableUser,
                          items: _unref(tenkoTypes),
                          "error-messages": __props.errors?.tenko_type
                        }, null, 8, ["modelValue", "disabled", "items", "error-messages"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["cols"])
      ]),
      _: 1
    }),
    (modelValue.value.is_active_ittenko && props.isEditableUser)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          class: "text-form pl-4 pr-3 mb-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: __props.windowInnerWidth > 800 ? 2 : 3
            }, {
              default: _withCtx(() => [
                _createElementVNode("h6", _hoisted_2, [
                  _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.operationOffices.form.ittenko.id')), 1),
                  _cache[4] || (_cache[4] = _createElementVNode("span", { style: {"color":"red"} }, "✴︎", -1))
                ])
              ]),
              _: 1
            }, 8, ["cols"]),
            _createVNode(_component_v_col, {
              cols: __props.windowInnerWidth > 800 ? 10 : 9
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: modelValue.value.ittenko_company_id,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modelValue.value.ittenko_company_id) = $event)),
                  maxlength: "255",
                  "error-messages": __props.errors?.ittenko_company_id
                }, null, 8, ["modelValue", "error-messages"])
              ]),
              _: 1
            }, 8, ["cols"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (modelValue.value.is_active_ittenko && props.isEditableUser)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 1,
          class: "text-form pl-4 pr-3 mb-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: __props.windowInnerWidth > 800 ? 2 : 3
            }, {
              default: _withCtx(() => [
                _createElementVNode("h6", _hoisted_3, [
                  _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.operationOffices.form.ittenko.privateKey')), 1),
                  _cache[5] || (_cache[5] = _createElementVNode("span", { style: {"color":"red"} }, "✴︎", -1))
                ])
              ]),
              _: 1
            }, 8, ["cols"]),
            _createVNode(_component_v_col, {
              cols: __props.windowInnerWidth > 800 ? 10 : 9
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: modelValue.value.ittenko_secret_key,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modelValue.value.ittenko_secret_key) = $event)),
                  maxlength: "255",
                  "error-messages": __props.errors?.ittenko_secret_key
                }, null, 8, ["modelValue", "error-messages"])
              ]),
              _: 1
            }, 8, ["cols"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})